<template>
  <div class="week-day-service-text" :class="getOccupation">
    <div>{{ ms.substr(0, 3) }} {{ getOccupationByServiceAndDay(date, ms) }}/{{ this.getAllCouverts(date, ms) }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CalendarService',
  props: ['ms', 'date', 'id', 'length', 'visibility'],
  computed: {
    ...mapGetters({
      getOccupationByServiceAndDay: 'newReservations/getOccupationByServiceAndDay',
      getAllCouverts: 'newRooms/getAllCouverts'
    }),
    getOccupation: function () {
      let percent = Math.round((this.getOccupationByServiceAndDay(this.date, this.ms) / this.getAllCouverts(this.date, this.ms)) * 100)
      switch (true) {
        case percent >= 0 && percent < 25:
          return 'green'
        case percent >= 25 && percent < 50:
          return 'yellow'
        case percent >= 50 && percent < 75:
          return 'orange'
        case percent >= 75:
          return 'red'
      }
    }
  }
}
</script>

<style lang="scss"></style>
